var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55558 20C7.06669 20 6.64818 19.8259 6.30003 19.4778C5.95188 19.1296 5.7778 18.7111 5.7778 18.2222V6.66667H4.88892V4.88889H9.33336V4H14.6667V4.88889H19.1111V6.66667H18.2222V18.2222C18.2222 18.7111 18.0482 19.1296 17.7 19.4778C17.3519 19.8259 16.9334 20 16.4445 20H7.55558ZM16.4445 6.66667H7.55558V18.2222H16.4445V6.66667ZM9.33336 16.4444H11.1111V8.44444H9.33336V16.4444ZM12.8889 16.4444H14.6667V8.44444H12.8889V16.4444Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1193d44f58f105d217ddc35ecb76820e.svg";
export { ForwardRef as ReactComponent };